import React from 'react';
import LinkButton from './LinkButton';

// Поля комплектации, которые бэкенд подмешивает к ремонту — живому и архивному.
export interface KitLinkFields {
  kit_id?: number | null;
  kit_title?: string | null;
  kit_archive_id?: number | null;
  kit_archive_title?: string | null;
  kit_archive_status?: 'given' | 'deleted' | null;
}

interface KitLinkProps {
  repair: KitLinkFields;
  onOpenKit?: (kitId: number, archived: boolean) => void;
}

// Активная комплектация — ссылка; архивная — тоже ссылка, но с пометкой; нет — прочерк.
const KitLink: React.FC<KitLinkProps> = ({ repair, onOpenKit }) => {
  if (repair.kit_id) {
    const label = repair.kit_title || `#${repair.kit_id}`;
    return onOpenKit
      ? <LinkButton onClick={() => onOpenKit(repair.kit_id as number, false)}>{label}</LinkButton>
      : <>{label}</>;
  }
  if (repair.kit_archive_id) {
    const suffix = repair.kit_archive_status === 'given' ? 'отдана' : 'в архиве';
    const label = `${repair.kit_archive_title || `#${repair.kit_archive_id}`} · ${suffix}`;
    return onOpenKit
      ? <LinkButton onClick={() => onOpenKit(repair.kit_archive_id as number, true)}>{label}</LinkButton>
      : <>{label}</>;
  }
  return <>—</>;
};

export default KitLink;
